export default "__VITE_ASSET__B$ovcQ9V__"